import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';import { concatLatestFrom } from '@ngrx/operators';

import { Store } from '@ngrx/store';
import { UiStorageService } from 'mbs-ui-shared@services';
import { of } from 'rxjs';
import { catchError, exhaustMap, filter, map } from 'rxjs/operators';
import { ApplicationStoreActions, ApplicationStoreSelectors } from '.';

@Injectable()
export class ApplicationStoreEffects {
  loadStorage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApplicationStoreActions.loadStorage),
      concatLatestFrom(() => this.store.select(ApplicationStoreSelectors.selectStorageLoaded)),
      filter(([action, loaded]) => action.force || !loaded),
      exhaustMap(() =>
        this.service.getSettings().pipe(
          map((payload) => ApplicationStoreActions.setStorage({ payload })),
          catchError(() => of(ApplicationStoreActions.setStorage({ payload: {} })))
        )
      )
    );
  });

  constructor(public store: Store, public actions$: Actions, private service: UiStorageService) {}
}
